<template>
	<div class="display-flex flex-row workflow-description flex-align-center">
		<ProjectChip v-if="showProjectChip" :projectId="flowData.project" />
		<div class="one-row">{{ flowType }}{{ flowLocation }}, {{ flowCreator }}</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import WorkflowService from '@/utils/WorkflowService';
import ProjectChip from '@/views/Flow/ProjectChip.vue';
import { mapGettersShorthand } from '@/store/utils/mappers';
import WorkflowToolService from '@/utils/workflow-tool-service';
import { getServiceBySlug } from '@/store/modules/apps/getters';
import { getPlacementVersion } from '@/store/modules/placements/modules/versions/getters';
import { getPlacement } from '@/store/modules/placements/getters';
export default {
	name: 'FlowFullDescription',
	components: { ProjectChip },
	props: {
		flowData: { type: Object },
		showProjectChip: { type: Boolean, default: true },
	},
	computed: {
		...mapGettersShorthand({ getServiceBySlug, getPlacement, getPlacementVersion }),
		...mapGetters('account', ['teamMembers']),
		isCommandBar() {
			return WorkflowToolService.isCommandBarTool(this.flowData);
		},
		flowLocation() {
			const location = WorkflowService.getFlowLocation(this.flowData, this.getServiceBySlug, this.getPlacement, this.getPlacementVersion);
			return location != '' ? ` ${location}` : '';
		},
		elementPlacement() {
			return this.getPlacement(this.flowData?.current_draft?.ui_element?.placement);
		},
		appName() {
			return this.getServiceBySlug(this.flowData?.context_service_slug)?.service_name;
		},
		contextLocation() {
			return this.elementPlacement?.item_name;
		},
		flowType() {
			return WorkflowService.getReadableFlowType(this.flowData, this.getPlacement, this.getPlacementVersion);
		},
		flowCreator() {
			if (this.installedFromInstallable) {
				return 'installed from marketplace'; // For now dont show who created it for installables
			}
			if (this.isOwner) {
				return 'created by you';
			}
			const member = this.teamMembers.find((member) => member.user_id === this.flowData.owner);
			if (member) {
				return 'created by ' + member.name;
			}
			return null;
		},
		installedFromInstallable() {
			return !!this.flowData.installed_from;
		},
		isOwner() {
			return this.flowData.is_owner;
		},
	},
};
</script>

<style scoped lang="scss">
.workflow-description {
	font-size: 12px;
	color: #9e9e9e;
	font-weight: 400;
}
.one-row {
	overflow: hidden;
	display: -webkit-box;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1; // num of rows to break
}
</style>
